module.exports = __webpack_public_path__ + "static/img/2.780ccb4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/2.jpeg
// module id = +9xt
// module chunks = 3